import '../../httpservices/core/ajax.httpservice.core';

class AppointmentHttpService {

    IndexInitData() {
        return $.get('Patient/Appointment/IndexInitData');
    }

    ConfirmAppointment(appointmentId) {
        return $.post('Patient/Appointment/ConfirmAppointment', appointmentId);
    }

    //mainly for the compose message - appt request screen
    GetFutureAppointments(enableOutageResponse) {
        if (enableOutageResponse === true) return $.get('Patient/Appointment/FutureAppointments?enableOutageResponse=1');
        return $.get('Patient/Appointment/FutureAppointments');
    }

    GetPastAppointments() {
        return $.get('Patient/Appointment/PastAppointments');
    }

    QuestionsForYourDoctorPageInit() {
        return $.get('Patient/Appointment/QuestionsForYourDoctorPageInit');
    }

    AddDoctorQuestion(questionText) {
        return $.post('Patient/Appointment/AddAQuestion', { questionToAdd: questionText });
    }

    DeleteQuestion(questionId) {
        return $.post('Patient/Appointment/RemoveAQuestion?questionId=' + questionId);
    }

    TelemedicineDetails(appointmentId) {
        return $.get('Patient/Appointment/TelemedicineDetails?appointmentId=' + appointmentId);
    }

    UpdatePatientTelemedicineContactInfo(appointmentId, patientPhones, patientEmails) {
        return $.post('Patient/Appointment/UpdatePatientTelemedinceContactInfo', { televisitId: appointmentId, patientPhones: patientPhones, patientEmails: patientEmails});
    }

    AddParticipant(appointmentId, saveModel) {
        return $.post('Patient/Appointment/AddParticipant', { televisitId: appointmentId, contact: this.ToParticipantSaveModel(saveModel) });
    }

    UpdateParticipant(appointmentId, currentRecipients, saveModel) {
        return $.post('Patient/Appointment/UpdateParticipant', { televisitId: appointmentId, currentContacts: currentRecipients, contactToUpdate: this.ToParticipantSaveModel(saveModel) });
    }

    ToParticipantSaveModel(saveModel) {
        return {
            id: saveModel.id,
            firstName: saveModel.firstName,
            middleName: saveModel.middleName,
            lastName: saveModel.lastName,
            email: saveModel.email,

            relationship: {
                id: saveModel.relationship,
                otherText: saveModel.otherText
            }
        };
    }

    ToTelemedContactsSaveModel(saveModel) {
        return {
            //televisitId: saveModel.televisitId,
            patientEmails: saveModel.patientEmails,
            patientPhones: saveModel.patientPhones
        };
    }

    RemoveParticipants(appointmentId, updatedRecipients) {
        return $.post('Patient/Appointment/RemoveParticipants', { televisitId: appointmentId, contacts: updatedRecipients });
    }

    GetTelevisitRelationships() {
        return $.get('Patient/Appointment/TelevisitRelationships');
    }

}

export const ApptHttpSvc = new AppointmentHttpService();